import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Pre-warm the Render backend so it's ready before the user navigates to blog
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';
fetch(`${API_BASE_URL}/api/health`, { method: 'GET' }).catch(() => {});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
